import React, { FC, useEffect, useRef } from 'react'

import ReactDOM from 'react-dom'
import { DragOverlay } from '@dnd-kit/core'

import { RegistrationFeesType } from '../../../../models/event-fees/event-fees.interface'

interface SortableOverlayProps {
  activeId: string | null
  fees: RegistrationFeesType[]
}

export const SortableOverlay: FC<SortableOverlayProps> = ({ activeId, fees }) => {
  const overlayContainerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    let el = document.getElementById('dnd-overlay-root') as HTMLDivElement | null
    if (!el) {
      el = document.createElement('div')
      el.id = 'dnd-overlay-root'
      Object.assign(el.style, {
        position: 'fixed',
        inset: '0',
        pointerEvents: 'none',
        transform: 'none',
        contain: 'layout style size',
        zIndex: '9999',
      } as CSSStyleDeclaration)
      document.body.appendChild(el)
    }
    overlayContainerRef.current = el
  }, [])

  return (
    overlayContainerRef.current &&
    ReactDOM.createPortal(
      <DragOverlay>
        {activeId && (
          <div className="flex flex-col justify-center py-2 pl-10 w-full min-h-[58px] rounded-lg border border-dashed border-SeabiscuitBlueThemeColor bg-blue-50 shadow-sm">
            <div className="flex w-11 absolute left-0 p-3 top-1.5">
              <img src="/assets/cp_icons/Move-1.svg" alt="moveIcon" className="w-full" />
            </div>
            <p className="text-[14px] text-SeabiscuitBlueThemeColor ellipsis">
              {fees.find((fee) => fee.uuid === activeId)?.name || ''}
            </p>
          </div>
        )}
      </DragOverlay>,
      overlayContainerRef.current
    )
  )
}
